const drawerWidth = 245;

export const MainPageUseStyles = (theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 0,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    background: "#ffffff",
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth - 78}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  menuButton: {
    marginRight: 10,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
  },

  drawerDark: {
    background: "#122742",
    color: "#fa0171",
  },

  drawerLight: {
    background: "#fa0171",
    color: "#ffffff",
  },

  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7.8) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(7.8) + 1,
    },
  },

  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    color: "#ffffff",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(0),
    background: "#fff",
    height: "fit-content",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    // overflowY: "scroll",
  },
  contentDark: {
    background: "#00152b",
    flexGrow: 1,
    padding: theme.spacing(0),
    height: "fit-content",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    // overflowY: "scroll",
  },
});
